import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import acesssAPI from "../api/acesssAPI";
import useTimer from "../hooks/useTimer";
import { authActions } from "../redux/actions";
import { isTokenExpired } from "../utils/isTokenExpired";
/* eslint-disable */
const useRenewToken = ({ startRenew, onError = (err) => console.log(err) }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const renewToken = useCallback(async () => {
    const res = await acesssAPI.renewToken().catch(onError);
    if (res?.token) {
      localStorage.setItem("token", res.token);
      localStorage.setItem("token_expired", +new Date());
      setLoading(false);
    } else {
      dispatch(authActions.logout());
      setLoading(false);
    }
  }, []);

  useTimer({
    start: startRenew,
    onTimeover: renewToken,
  });

  useEffect(() => {
    if (isTokenExpired()) {
      if (startRenew) {
        dispatch(authActions.logout());
        console.log("NAVIGATOR_LOGOUT");      
        acesssAPI.logout().catch(onError);
      }
      setLoading(false);
    } else {
      renewToken();
      console.log("NAVIGATOR_RENEW");
    }
  }, []);

  return { loading };
};

export default useRenewToken;
